import React from "react";
import {LanguageProp} from "../../config/LanguageConfig";
import {APP_CONFIG} from "../../config/GeneralConfig";
import {ReactChildren} from "../../models/common/ReactChildren";

export interface ErrorBoundaryProps extends LanguageProp, ReactChildren {

}

interface ErrorBoundaryState {
    hasError: boolean
}

class ErrorBoundary extends React.Component< ErrorBoundaryProps, ErrorBoundaryState> {

    constructor( props: any ) {
        super( props );

        this.state = {
            hasError: false
        };
    }

    static getDerivedStateFromError( error: any ) {
        // Update state so the next render will show the fallback UI.
        if( APP_CONFIG.devMode ) {
            console.log(error);
        }

        return { hasError: true };
    }

    render() {
        if( this.state.hasError ) {
            return (
                <h1>
                    { this.props.language.errors.errorBoundaryMessage.errorText }
                </h1>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;